import { useState } from "react";
import { Play, Video } from "lucide-react";
import YoutubeThumbnail from "../../components/YoutubeThumbnail";
import { youtubeEmbedUrl } from "../../lib/youtubeVideos";

/**
 * Product demo slot — placeholder until a recording is ready, or a YouTube thumbnail that plays inline when clicked.
 */
export default function Nd1DemoVideoPlaceholder({
  slotId,
  note,
  playLabel,
  accent = false,
  videoId = "",
  thumbnailAlt = "",
}) {
  const [playing, setPlaying] = useState(false);
  const shellClass = accent ? "nd1-hm-video" : "nd1-js-hero__video";
  const playClass = accent ? "nd1-hm-video__play" : "nd1-js-hero__video-play";
  const id = String(videoId || "").trim();
  const label = playLabel || (id ? "Play product demo video" : "Product demo video placeholder");

  if (id && playing) {
    const embedSrc = `${youtubeEmbedUrl(id)}&autoplay=1`;

    return (
      <div
        className={`${shellClass} nd1-demo-video--playing`}
        data-video-slot={slotId}
        aria-label={label}
      >
        <div className="nd1-demo-video__embed">
          <iframe
            src={embedSrc}
            title={label}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </div>
      </div>
    );
  }

  if (id) {
    return (
      <button
        type="button"
        className={shellClass}
        data-video-slot={slotId}
        onClick={() => setPlaying(true)}
        aria-label={label}
      >
        <YoutubeThumbnail
          videoId={id}
          alt={thumbnailAlt || label}
          loading="eager"
          fetchPriority="high"
        />
        <span className={playClass} aria-hidden="true">
          <Play className="nd1-icon" aria-hidden="true" />
        </span>
      </button>
    );
  }

  return (
    <div
      className={shellClass}
      data-video-slot={slotId}
      aria-label={label}
      role="img"
    >
      <div className="nd1-js-hero__video-placeholder">
        <Video className="nd1-icon" aria-hidden="true" />
        <span>{note || "Product demo coming soon"}</span>
      </div>
      <span className={playClass} aria-hidden="true">
        <Play className="nd1-icon" aria-hidden="true" />
      </span>
    </div>
  );
}
